export type Props = React.SVGAttributes<SVGElement>

export const Arrow: React.FC<Props> = (props) => (
  <svg viewBox="0 0 69 95" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M0 1s49-7 65 11c15 15-20 67-20 67s13 4 14 6-20 11-24 10-15-19-14-21c2-2 16 3 16 3s26-51 16-60C39 5 1 7 1 7L0 1Z"
      fill="currentColor"
    />
  </svg>
)
